import { useEffect } from "react";

import { useLocalStorage } from "../useLocalStorage";

// Volume do alerta sonoro, de 0 a 1.
//
// Não havia como baixar nem calar: o som tocava sempre no volume cheio, a cada
// mensagem nova. Em sala com várias pessoas atendendo, isso é o dia inteiro.
//
// Fica no navegador, não no cadastro: é preferência de quem está sentado
// naquela máquina — o mesmo atendente quer som no computador da mesa e
// silêncio no notebook de casa.
export const VOLUME_PADRAO = 0.5;
const EVENTO_VOLUME_ALTERADO = "whaticket:volume-do-alerta-alterado";

export function useVolumeDoAlerta() {
  const [volume, setVolume] = useLocalStorage(
    "volumeDoAlerta",
    VOLUME_PADRAO,
  );

  // Vindo do armazenamento, o valor pode ser qualquer coisa (edição manual,
  // versão antiga). Um volume fora de 0..1 faz o Howler recusar o som e o
  // alerta some sem aviso.
  const seguro =
    typeof volume === "number" && volume >= 0 && volume <= 1
      ? volume
      : VOLUME_PADRAO;

  // O controle, as notificações de atendimento e o chat interno montam este
  // hook separadamente. Cookie não dispara evento na própria aba, então sem
  // esta sincronização só o controle mudava; quem toca o som mantinha o
  // volume lido ao abrir a página até o próximo F5.
  useEffect(() => {
    const sincronizar = (evento) => setVolume(evento.detail);
    window.addEventListener(EVENTO_VOLUME_ALTERADO, sincronizar);
    return () => window.removeEventListener(EVENTO_VOLUME_ALTERADO, sincronizar);
  }, [setVolume]);

  const definirVolume = (novoVolume) => {
    const proximo =
      typeof novoVolume === "function" ? novoVolume(seguro) : novoVolume;

    setVolume(proximo);
    window.dispatchEvent(
      new CustomEvent(EVENTO_VOLUME_ALTERADO, { detail: proximo }),
    );
  };

  return {
    volume: seguro,
    setVolume: definirVolume,
    mudo: seguro === 0,
    // Calar guarda o volume anterior para o botão devolver o mesmo nível, em
    // vez de sempre voltar ao padrão.
    alternarMudo: () => definirVolume(seguro === 0 ? VOLUME_PADRAO : 0),
  };
}

export default useVolumeDoAlerta;
